export default "__VITE_ASSET__BC7BrAo3__"